import VueChartJs from 'vue-chartjs'

export default {
  extends: VueChartJs.Bar,
  props: ['chartData', 'labels'],
  data: function () {
    return {
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: 17,
              beginAtZero: true
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: false,
          mode: 'single',
          callbacks: {
            label: function (tooltipItems, data) {
              return tooltipItems.yLabel
            }
          }
        },
        responsive: false,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    this.render()
  },
  watch: {
    'chartData' (to, from) {
      this.render()
    },
    'labels' (to, from) {
      this.render()
    }
  },
  methods: {
    render () {
      console.log('render')
      var data = {
        label: 'Data One',
        backgroundColor: '#219EBC',
        pointBackgroundColor: 'white',
        borderWidth: 3,
        pointBorderColor: '#219EBC',
        data: this.chartData
      }

      this.renderChart({
        labels: this.labels,
        datasets: [
          data
        ]
      }, this.options)
    },
    export2image: function () {
      let image = document.getElementById(this.$attrs.id).querySelector('canvas').toDataURL('image/png')
      return image
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BarChart.js